import { render, staticRenderFns } from "./AutoPostDepositsModal.vue?vue&type=template&id=21fb7165&scoped=true&"
import script from "./AutoPostDepositsModal.vue?vue&type=script&lang=js&"
export * from "./AutoPostDepositsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb7165",
  null
  
)

export default component.exports